import React, { useCallback } from 'react';
import { RouteComponentProps } from 'react-router';

import useCustomer from 'core/hooks/useCustomer';
import { CustomerFormSchema } from 'core/schemas/customerForm';
import { FormSubmitHandler } from 'Elements/Form';

import CustomerForm from './CustomerPage/CustomerForm';
import CustomerPage from './CustomerPage/CustomerPage';

type Props = RouteComponentProps<{ id: string }>;

export default function CustomerDetail({ match }: Props) {
  const { customer, update } = useCustomer(match.params.id);

  const onSubmit: FormSubmitHandler<CustomerFormSchema> = useCallback(
    (values, form) => {
      return Promise.all([update(values.customer)]).catch(errors =>
        form.setErrors({ customer: errors })
      );
    },
    [update]
  );

  return (
    <CustomerForm id={+match.params.id} onSubmit={onSubmit} customer={customer}>
      <CustomerPage
        title={customer ? customer.company : '–'}
        subtitle={customer ? `${customer.number}` : '–'}
      />
    </CustomerForm>
  );
}
